import { type DependencyList, useEffect, useState } from 'react';

const useAsyncMemo = <T>(
  factory: () => Promise<T> | undefined | null,
  deps: DependencyList,
  initial?: T
) => {
  const [data, setData] = useState<T | undefined>(initial);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    let cancel = false;
    // factory?.() is optional because of tests failure (we don't have electron object on window in tests)
    // TODO: mock the electron object in tests
    const promise = factory?.();

    if (promise !== undefined && promise !== null) {
      promise
        .then((val) => {
          if (!cancel) {
            setData(val);
            setIsLoading(false);
          }
          return undefined;
        })
        .catch((e) => {
          console.error('Error in useAsyncMemo', e);
        });
    }

    return () => {
      cancel = true;
    };
  }, deps);

  return { data, isLoading };
};

export default useAsyncMemo;
